export const addOnOptions = [
    {
      id: 'chest_xray',
      label: '胸部 X 光檢查',
      price: 1000,
      info: null
    },
    {
      id: 'gastroscopy',
      label: '胃鏡',
      price: 8000,
      info: [
        '檢查前需空腹 8 小時',
        '請提前告知醫師相關病史',
        '檢查當日請攜帶身分證件',
        '檢查後 1 小時內請勿進食'
      ]
    },
    {
      id: 'abdominal_ultrasound',
      label: '腹部超音波',
      price: 5000,
      info: null
    },
    {
      id: 'thyroid_ultrasound',
      label: '甲狀腺超音波',
      price: 6000,
      info: [
        '檢查過程約 15-20 分鐘'
      ]
    }
  ];